import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { cx } from '../../../util/classname.js';
import '../../Box/index.js';
import '../../Icon/index.js';
import { useExperimentContext } from '../../../contexts/session/Experiment.js';
import { ICON_CONTAINER_CLASS } from './constants.js';
import { Box } from '../../Box/Box.js';
import { Icon } from '../../Icon/Icon.js';

var _excluded = ["color", "className"];
var IconWrapper = function IconWrapper(props) {
  var experiments = useExperimentContext();
  if (experiments.iconsMigrationToV3) {
    var color = props.color,
      className = props.className,
      rest = _objectWithoutProperties(props, _excluded);
    return /*#__PURE__*/React.createElement(Box, {
      as: "span",
      display: "inline-flex",
      textColor: color,
      className: cx([className, ICON_CONTAINER_CLASS], false)
    }, /*#__PURE__*/React.createElement(Icon, rest));
  }
  return /*#__PURE__*/React.createElement(Icon, props);
};

export { IconWrapper };
//# sourceMappingURL=IconWrapper.js.map
